import React from "react";
import { LoadingIndicator } from "./LoadingIndicator";

export function AgentPlaceholder({
  isFiltered,
  isFetching,
  onClearFilters,
}: {
  isFiltered: boolean;
  isFetching: boolean;
  onClearFilters: () => void;
}) {
  return (
    <div className="flex flex-col gap-1 items-center justify-center h-full text-gray-500">
      {isFetching ? (
        <LoadingIndicator />
      ) : (
        <React.Fragment>
          <h3 className="font-semibold text-gray-900">No agents found.</h3>
          {isFiltered && (
            <div className="flex flex-col gap-5">
              <p className="text-gray-500">
                Please adjust your search criteria.
              </p>
              <button
                type="button"
                onClick={onClearFilters}
                className="rounded-md bg-brand-primary px-3.5 py-2.5 text-sm font-semibold text-brand-foreground shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-primary"
              >
                Clear filters
              </button>
            </div>
          )}
        </React.Fragment>
      )}
    </div>
  );
}
